import React from 'react'
import {connect} from 'react-redux';
import {socketsConnecting} from "../../actions/websocketAction";


class Websocket extends React.Component {
  componentDidMount() {
    if (this.props.token !== "" ) {
      this.props.socketsConnecting(this.props.conn, this.props.token);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.props.socketsConnecting(this.props.conn, this.props.token);
      return false
    }

    if (this.props.token !== "" && this.props.conn === null) {
      this.props.socketsConnecting(this.props.conn, this.props.token);
      return false
    }
  }

  render() {
    return ''
  }
};

const mapStateToProps = state => ({
  token: (state.user.profile.token) ? state.user.profile.token : "",
  conn: state.websocket.conn
});

const mapDispatchToProps = (dispatch) => {
  return {
    socketsConnecting(conn, token) {
      dispatch(socketsConnecting(conn, token));
    }
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(Websocket)
